import { type ReactNode, useState } from 'react';
import { Row, Text } from '~/commonComponents';
import { CheckIcon } from '~/images/icons/CheckIcon';
import { Colors } from '~/themes/colors';

interface IDropdownOptionProps {
  isSelected: boolean;
  onSelect: () => void;
  children: ReactNode;
  testId?: string;
  bold?: boolean;
}

export const DropdownOption = ({
  isSelected,
  onSelect,
  children,
  testId,
  bold,
}: IDropdownOptionProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Row
      data-testid={testId}
      alignItems="center"
      borderRadius={8}
      backgroundColor={isHovered ? Colors.secondary_500 : undefined}
      onClick={(e) => {
        e.stopPropagation();
        onSelect();
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      gap={8}
      style={{
        padding: '8px 14px',
        cursor: 'pointer',
        transition: 'background-color 0.15s, opacity 0.15s',
      }}
    >
      <div style={{ width: 20, height: 20, flexShrink: 0 }}>
        {isSelected && (
          <CheckIcon size={20} color={isHovered ? Colors.white : Colors.neutral_600} />
        )}
      </div>
      <Text
        fontSize={16}
        bold={isSelected || bold}
        color={isHovered ? 'white' : 'neutral_600'}
      >
        {children}
      </Text>
    </Row>
  );
};
